import Vue from "vue";
import 'tsa-ui/lib/theme-chalk/index.css';
import {
    Button,
    Select,
    Option,
    Input,
    Radio,
    RadioGroup,
    RadioButton,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Loading,
    Message,
    MessageBox,
    Tooltip,
    DatePicker,
    Dialog,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Form,
    FormItem,
    CustomizeMessageBox,
    CustomizeToast,
    SlideMenu,
    CustomizeTable,
    TableColumn,
    Table,
    Popover,
    Row,
    Col,
    Scrollbar,
    Drawer,
    Carousel,
    CarouselItem,
    Progress,
    InputNumber,
    ConditionInput,
    ConditionDatePicker,
} from "tsa-ui";

Vue.use(Button)
    .use(Tooltip)
    .use(DatePicker)
    .use(Dialog)
    .use(Dropdown)
    .use(DropdownMenu)
    .use(DropdownItem)
    .use(Form)
    .use(FormItem)
    .use(Loading)
    .use(Button)
    .use(Select)
    .use(Option)
    .use(Input)
    .use(Radio)
    .use(RadioGroup)
    .use(RadioButton)
    .use(Checkbox)
    .use(CheckboxButton)
    .use(CheckboxGroup)
    .use(CustomizeMessageBox)
    .use(CustomizeToast)
    .use(SlideMenu)
    .use(CustomizeTable)
    .use(TableColumn)
    .use(Table)
    .use(Popover)
    .use(Row)
    .use(Col)
    .use(Scrollbar)
    .use(Drawer)
    .use(Carousel)
    .use(CarouselItem)
    .use(Progress)
    .use(InputNumber)
    .use(ConditionInput)
    .use(ConditionDatePicker)

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$TsaCustomizeAlert = CustomizeMessageBox.alert
Vue.prototype.$TsaCustomizeConfirm = CustomizeMessageBox.confirm
Vue.prototype.$TsaCustomizeToast = CustomizeToast

import TsaTooltipV2 from '@/components/copyright/basics/tooltipV2'
import TsaTooltipCustomV2 from '@/components/copyright/basics/tooltipCustomV2'
import TsaDialogV2 from '@/components/copyright/basics/dialogV2'
import TsaTable from '@/components/copyright/basics/table'
import TsaPager2 from '@/components/copyright/basics/pagerV2'
import TsaInput2 from '@/components/copyright/basics/inputV2'
import TsaButton from '@/components/copyright/basics/button'
import TsaTableActionPopover from '@/components/copyright/basics/table/tableActionPopover'
import TsaConditionSearchV2 from '@/components/copyright/basics/conditionSearchV2'
import TsaConditionSearchV21 from '@/components/copyright/basics/conditionSearchV2'
import TsaHashButton from '@/components/copyright/basics/hashButton'
import TsaConditionInputV2 from '@/components/copyright/basics/conditionInputV2'
import TsaSelectV2 from '@/components/copyright/basics/selectV2'
import TsaConditionDateV2 from '@/components/copyright/basics/conditionDateV2'
import TsaList from '@/components/copyright/basics/list'
import TsaListItem from '@/components/copyright/basics/listItem'
import TsaConditionSelectV2 from '@/components/copyright/basics/conditionSelectV2'
import TsaSubTitle from '@/components/copyright/basics/subTitle'
import TsaPullToRefresh from '@/components/copyright/basics/pullToRefresh'
import TsaCheckboxV2 from '@/components/copyright/basics/checkboxV2'
import TsaRadioV2 from '@/components/copyright/basics/radioV2'

Vue.component('TsaTooltipV2', TsaTooltipV2)
Vue.component('TsaTooltipCustomV2', TsaTooltipCustomV2)
Vue.component('TsaDialogV2', TsaDialogV2)
Vue.component('TsaTable', TsaTable)
Vue.component('TsaPager2', TsaPager2)
Vue.component('TsaInput2', TsaInput2)
Vue.component('TsaButton', TsaButton)
Vue.component('TsaTableActionPopover', TsaTableActionPopover)
Vue.component('TsaConditionSearchV21', TsaConditionSearchV21)
Vue.component('TsaConditionInputV2', TsaConditionInputV2)
Vue.component('TsaConditionSearchV2', TsaConditionSearchV2)
Vue.component('TsaHashButton', TsaHashButton)
Vue.component('TsaSelectV2', TsaSelectV2)
Vue.component('TsaConditionDateV2', TsaConditionDateV2)
Vue.component('TsaList', TsaList)
Vue.component('TsaListItem', TsaListItem)
Vue.component('TsaConditionSelectV2', TsaConditionSelectV2)
Vue.component('TsaSubTitle', TsaSubTitle)
Vue.component('TsaPullToRefresh', TsaPullToRefresh);
Vue.component('TsaCheckboxV2', TsaCheckboxV2)
Vue.component('TsaRadioV2', TsaRadioV2)

Vue.config.productionTip = false;

import { TsaAlertV2, TsaConfirmV2, TsaToastV2, TsaLoadingV2, TsaIframeDialog, TsaPreviewVideo, TsaProgress } from '@/plugins/copyright/common'
Vue.use(TsaAlertV2).use(TsaConfirmV2).use(TsaToastV2).use(TsaLoadingV2).use(TsaIframeDialog).use(TsaPreviewVideo).use(TsaProgress)
